import { Category, ParentCategory } from "../../typings/Category"
import { BreadCrumbAncestor } from "../../components/BreadCrumbs"
import getValueFromLocalizedStringWithFallback from "../i18n/getValueFromLocalizedStringWithFallback"

const getAncestors = (parentCategory: ParentCategory, locale: string) => {
	const { slug, parent, nameAllLocales } = parentCategory
	const name = getValueFromLocalizedStringWithFallback(nameAllLocales, locale)

	const breadCrumbPath = {
		name,
		slug,
	}

	if (!parent) return [breadCrumbPath]

	return [...getAncestors(parent, locale), breadCrumbPath]
}

export const getTopLevelCategoryBreadCrumb = ({ name, slug }) => {
	const topLevelCategoryBreadCrumb: BreadCrumbAncestor = {
		label: name,
		href: `/pc/${slug}`,
	}

	return topLevelCategoryBreadCrumb
}

export const getCategoryBreadCrumb = ({ name, slug }) => {
	const ancestor: BreadCrumbAncestor = {
		label: name,
		href: `/c/${slug}`,
	}

	return ancestor
}

const getCategoryBreadCrumbs = (category: Category, locale: string) => {
	const { parent } = category
	const ancestors = getAncestors(parent, locale)

	const [
		topLevelCategory,
		/*eslint-disable*/ hiddenCategory,
		/*eslint-enable*/ ...parentCategories
	] = ancestors

	const topLevelCategoryBreadCrumb = getTopLevelCategoryBreadCrumb(topLevelCategory)

	const categoryAncestors = parentCategories.map(getCategoryBreadCrumb)

	const breadCrumbsAncestors: BreadCrumbAncestor[] = [
		topLevelCategoryBreadCrumb,
		...categoryAncestors,
	]

	return breadCrumbsAncestors
}

export default getCategoryBreadCrumbs
